import { Box, Button, type ButtonProps, Popover } from '@mantine/core';
import { IconMessageShare } from '@tabler/icons-react';
import { FeedbackForm } from 'components/FeedbackForm';
import { iconProps } from 'components/icon-props';
import { tKeys, useTranslation } from 'locales';
import type React from 'react';

type FeedbackButtonProps = ButtonProps &
  React.ComponentProps<typeof Button> &
  React.HTMLAttributes<HTMLButtonElement> & {
    description?: string;
    featureName: string;
    position?: React.ComponentProps<typeof Popover>['position'];
  };

export const FeedbackButton = ({
  description,
  featureName,
  position = 'bottom',
  ...buttonProps
}: FeedbackButtonProps) => {
  const { t } = useTranslation();

  return (
    <Box onClick={e => e.stopPropagation()}>
      <Popover shadow="md" position={position}>
        <Popover.Target>
          <Button
            leftSection={<IconMessageShare {...iconProps()} />}
            variant="light"
            {...buttonProps}
          >
            {t(tKeys.FEEDBACK.BUTTON)}
          </Button>
        </Popover.Target>
        <Popover.Dropdown miw={400} mih={220}>
          <FeedbackForm description={description} featureName={featureName} />
        </Popover.Dropdown>
      </Popover>
    </Box>
  );
};
